import ApplicationAdapter from 'eflex/adapters/application';

export default class OpcUaAdapter extends ApplicationAdapter {
  pathForType() {
    return 'hardwares';
  }
}
